import React from 'react';
import { View, StyleSheet } from 'react-native';
import Colors from '../constants/Colors';

export default function CenterSeparator() {
  return (
    <View style={styles.container}>
      <View style={styles.separator} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    // width: '100%',
    flex: 1,
    alignItems: 'center',
    // height: 61,
  },
  separator: {
    marginVertical: 50,
    borderStyle: 'solid',
    borderTopWidth: 1,
    borderColor: Colors.lightBlue,
    width: 100,
  }
})
